var _defs, _circle, _line, _line2, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 333.75 384.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:24px;}.cls-1,.cls-2{stroke-miterlimit:10;}.cls-1,.cls-2,.cls-3{fill:none;stroke:#000;}.cls-2,.cls-3{stroke-linecap:round;stroke-width:22px;}.cls-3{stroke-linejoin:round;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 243.91,
    cy: 89.84,
    r: 77.84
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 222.4,
    y1: 68.91,
    x2: 264.02,
    y2: 110.52
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 264.02,
    y1: 68.91,
    x2: 222.4,
    y2: 110.52
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M167.05,77.47H11c33.7,49.4,67.4,98.8,101.11,148.2v148.09c19.23-12.94,38.47-25.87,57.7-38.81v-104.68c15.25-22.64,30.51-45.27,45.76-67.91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearFilterIcon);
export default __webpack_public_path__ + "static/media/clear-filter-icon.2dfb76ffe197801dd3bd49dd327e49ac.svg";
export { ForwardRef as ReactComponent };